import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

import PDPFeatureImage from "./pdp-feature-image";
import Counter from "./imagery/counter";
import { getProductImageUrlsByOrientation } from "helpers/product-image-helpers";

export const PDPImagery = props => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;

      const scrollLeft = containerRef.current.scrollLeft;
      const containerWidth = containerRef.current.clientWidth;
      const newIndex = Math.round(scrollLeft / containerWidth) + 1;

      setCurrentIndex(newIndex);
    };

    const container = containerRef.current;
    container.addEventListener("scroll", handleScroll);

    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  const getFilteredImages = () => {
    const filteredImages = {};
    for (const orientation of props.imageRotation) {
      const image = props.images?.[orientation];
      if (image) filteredImages[orientation] = image;
    }
    return filteredImages;
  };

  const {
    isCloudZoomEnabled,
    isMobileViewport,
    className,
    onClick,
    onVisible,
    lazy,
    altText,
    additionalImages = [],
    isDrawer = false,
    isZoomedIn = false,
    isSelectedSizeAvailable = true,
  } = props;

  const imageOrderList = Object.keys(getFilteredImages());

  const mainImagesLength = props.images ? Object.keys(props.images).length : 0;
  const totalImages = additionalImages?.length > 0 ? mainImagesLength + 1 : mainImagesLength;

  return (
    <>
      <div className={className} ref={containerRef} data-test-id="pdp-imagery-container">
        {imageOrderList.map((image, index) => (
          <PDPFeatureImage
            key={index}
            index={index}
            isMobileViewport={isMobileViewport}
            imageGroup={getProductImageUrlsByOrientation(props.images, [image])}
            isCloudZoomEnabled={isCloudZoomEnabled}
            onClick={onClick}
            onVisible={onVisible}
            lazy={lazy}
            altText={`${altText} ${index}`}
            isDrawer={isDrawer}
            isZoomedIn={isZoomedIn}
            isSelectedSizeAvailable={isSelectedSizeAvailable}
          />
        ))}
        {additionalImages.map(image => image)}
      </div>
      {isMobileViewport && <Counter current={currentIndex} total={totalImages} />}
    </>
  );
};

PDPImagery.propTypes = {
  additionalImages: PropTypes.array,
  altText: PropTypes.string,
  className: PropTypes.string,
  imageRotation: PropTypes.array,
  images: PropTypes.object,
  isCloudZoomEnabled: PropTypes.bool.isRequired,
  isMobileViewport: PropTypes.bool,
  lazy: PropTypes.bool,
  onClick: PropTypes.func,
  onVisible: PropTypes.func,
  isDrawer: PropTypes.bool,
  isZoomedIn: PropTypes.bool,
  isSelectedSizeAvailable: PropTypes.bool,
};

export default PDPImagery;
